import React from 'react';

const BasicInfoStep = ({ formData, updateFormData, errors, showUsername = false }) => {
    const getCharacterCount = (text, max) => {
        const current = text ? text.length : 0;
        return `${current}/${max}`;
    };

    const getCharacterCountClass = (text, min, max) => {
        const current = text ? text.length : 0;
        if (current < min) return 'character-count warning';
        if (current > max * 0.9) return 'character-count near-limit';
        return 'character-count';
    };

    return (
        <div className="step-content-wrapper">
            <div className="step-header">
                <h2>Información Básica</h2>
                <p>Completa la información principal de tu perfil</p>
            </div>

            <div className="form-section">
                {showUsername && (
                    <div className="form-group">
                        <label htmlFor="username">
                            Nombre de usuario <span className="required">*</span>
                        </label>
                        <div className="field-help">
                            Este será visible en tu perfil y cuando compartas tu link. Solo letras y guiones. Sin espacios.
                        </div>
                        <input
                            id="username"
                            type="text"
                            className={`form-input ${errors.username ? 'error' : ''}`}
                            placeholder="Ej: juanperez"
                            value={formData.username || ''}
                            onChange={(e) => {
                                const value = (e.target.value || '').replace(/\s/g, '');
                                updateFormData('username', value);
                            }}
                            maxLength={30}
                        />
                        <div className="field-footer">
                            {errors.username && <span className="error-message">{errors.username}</span>}
                            <span className={getCharacterCountClass(formData.username, 1, 30)}>
                                {getCharacterCount(formData.username, 30)}
                            </span>
                        </div>
                    </div>
                )}

                <div className="form-group">
                    <label htmlFor="name">
                        Nombre del perfil <span className="required">*</span>
                    </label>
                    <div className="field-help">
                        Este será el nombre principal que verán tus clientes.
                    </div>
                    <input
                        id="name"
                        type="text"
                        className={`form-input ${errors.name ? 'error' : ''}`}
                        placeholder="Ej: Electricista Juan Pérez"
                        value={formData.name || ''}
                        onChange={(e) => updateFormData('name', e.target.value)}
                        maxLength={100}
                    />
                    <div className="field-footer">
                        {errors.name && <span className="error-message">{errors.name}</span>}
                        <span className={getCharacterCountClass(formData.name, 1, 100)}>
                            {getCharacterCount(formData.name, 100)}
                        </span>
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="description">
                        Descripción <span className="required">*</span>
                    </label>
                    <div className="field-help">
                        Describe tu negocio, servicios y experiencia. Incluye detalles que ayuden a los clientes a conocerte mejor.
                    </div>
                    <textarea
                        id="description"
                        className={`form-textarea ${errors.description ? 'error' : ''}`}
                        placeholder="Describe tu negocio, servicios y experiencia. Incluye detalles que ayuden a los clientes a conocerte mejor..."
                        value={formData.description || ''}
                        onChange={(e) => updateFormData('description', e.target.value)}
                        rows={6}
                        maxLength={1000}
                    />
                    <div className="field-footer">
                        {errors.description && <span className="error-message">{errors.description}</span>}
                        <span className={getCharacterCountClass(formData.description, 1, 1000)}>
                            {getCharacterCount(formData.description, 1000)}
                        </span>
                    </div>
                </div>

                {/* Horarios de atención se gestiona en Contacto para evitar duplicados */}
            </div>
        </div>
    );
};

export default BasicInfoStep;
